export enum ContainerSizeEnum {
    TWENTYFT = '20FT',
    FORTYFT = '40FT',
  }
